import React, { useRef, useState } from "react";
import SubmitIcon from "./Submit";
import Link from "../../utils/link";
import { graphql, useStaticQuery } from "gatsby";
import useStoryblok from "../../lib/storyblok";

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      storyblokEntry(full_slug: { eq: "footer" }) {
        id
        content
      }
    }
  `);

  const entry = useStoryblok(data.storyblokEntry);

  const content = entry.content;

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    let myForm = formRef.current;
    let formData = new FormData(myForm);
    fetch("/api/mailchimp", {
      method: "POST",
      body: JSON.stringify(Object.fromEntries(formData)),
    })
      .then(() => console.log("Form successfully submitted"))
      .catch((error) => alert(error));
    setHasSubmitted(true);
  };

  const triggerPopup = () => {
    window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'Wkh43K']);
  }

  return (
    <footer className="bg-black text-white text-sm lg:text-lg pt-10 pb-0 lg:pt-8 lg:pb-2 width font-medium">
      <div className="border-t border-white py-10 lg:py-8 grid grid-cols-2 lg:grid-cols-6">
        <div className="space-y-6">
          <h2>
            © {new Date().getFullYear()}
            <br />
            <Link to="/" className="hover-underline-animation">
              Willow & Blake
            </Link>
          </h2>
          <ol>
            {content.link_group.map((social, index) => {
              return (
                <li key={`social-${index}`}>
                  <Link
                    to={social.link.cached_url}
                    className="hover-underline-animation"
                  >
                    {social.title}
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>

        <div className="space-y-6 ml-[-15px] lg:ml-0">
          <ol>
            {content.contact_info.map((info, index) => {
              return (
                <li key={`contact-info-${index}`}>
                  <Link
                    to={info.link.cached_url}
                    className="hover-underline-animation"
                  >
                    {info.title}
                  </Link>
                </li>
              );
            })}
          </ol>

          <ol>
            {content.address_blocks.map((info, index) => {
              return (
                <li key={`contact-info-${index}`}>
                  <Link
                    to={info.link.cached_url}
                    className="hover-underline-animation"
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: info.title }}
                    ></span>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>

        <div className="col-span-2 lg:col-span-4 lg:max-w-[44rem] lg:ml-auto pt-10 mt-10 lg:mt-0 lg:pt-0 border-t border-white lg:border-t-0 lg:mr-8">
          <h3
            className="text-base lg:text-3xl lg:mr-24 pb-6 whitespace-nowrap font-semibold"
            dangerouslySetInnerHTML={{ __html: content.email_cta }}
          ></h3>
          <button className="btn w-full bg-[#A2E3BA] text-black leading-[normal]" onClick={triggerPopup}>SIGN ME UP</button>
          {hasSubmitted && (
            <p className="text-white text-sm lg:text-lg pt-4 underline font-semibold">
              Thank you for subscribing!
            </p>
          )}
        </div>

        <p
          className="col-span-2 lg:col-span-6 pt-10"
          dangerouslySetInnerHTML={{ __html: content.aoc }}
        ></p>
      </div>
    </footer>
  );
};

export default Footer;
